// extracted by mini-css-extract-plugin
export default {"Resume":"resume-form_Resume__AuPZ8","buttonAdd":"resume-form_buttonAdd__BdE+1","list-item":"resume-form_list-item__p7tBS"};